import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';

@Component({
    selector: 'kx-hdfc-payment-status',
    templateUrl: './hdfc-payment-status.component.html',
    styleUrls: ['./hdfc-payment-status.component.scss'],
    standalone: false
})
export class HdfcPaymentStatusComponent implements OnInit {
  _resourceDef: any;
  result: any;
  showbackButton: boolean = true;

  constructor(
    private route: Router,
    private alert: AlertsService,
    private Aroute: ActivatedRoute,
    private baseService: BaseService,
    public utilService: UtilService
  ) { }

  ngOnInit(): void {
    this.baseService.getResourceDef(this.Aroute.snapshot.data.resource, (_resourceName) => {
      if (_resourceName) {
        this._resourceDef = _resourceName;
        this.getData()
      }
    })
  }

  getData() {
    let queryId = this._resourceDef.form.datasource.query_id != undefined ? this._resourceDef.form.datasource.query_id : "GET_PAGE";
    let args = this.baseService.buildDyanamicStr(this._resourceDef.form.datasource.args, { data: JSON.parse(sessionStorage.getItem('currentData')) });
    let resource = this._resourceDef.form.datasource.resource;
    let application = this._resourceDef.form.datasource.application;
    this.baseService.get(queryId, args, resource, application).subscribe((res: any) => {
      if (res.errCode == 0) {
        this.result = res.resource[0];
      } else {
        this.alert.error(res.message)
      }
    }, (err: any) => {
      console.log("Error in getting data :: ", err);
    })
  }

  previous(){
    this.route.navigateByUrl(this.Aroute.snapshot.queryParams.returnUrl);
  }

}
